import React from "react";

import Modal from "../../../../components/elements/Modal";
import ManagePost from "../ManagePost";

const ManagePostModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl2"
      title={data?._id ? "Update One" : "Create New"}
    >
      <ManagePost getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManagePostModal;
